class Workout {
  constructor({ id, startedAt, endedAt = null }) {
    this.id = id
    this.startedAt = startedAt
    this.endedAt = endedAt
    this.performances = []
  }

  hasCompleted(exerciseId) {
    return this.performances.some(performance => performance.exerciseId === exerciseId && performance.completedAt)
  }
}

export default Workout
